module.exports = __webpack_public_path__ + "img/worldPicture.fe5acf0c.png";